import React from 'react';
import { Helmet } from 'react-helmet';

const Header = ({ data }) => {
  const checkForColour = (data) => {
    if (data.facolour) {
      return data.facolour[0];
    }
    if (data.colour) {
      return data.colour[0];
    }
  };

  return (
    <Helmet>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0"
        data-react-helmet="true"
      />

      <title>
        {data[0]?.product?.attributes?.brand +
          ' ' +
          data[0].product.name +
          ' | ' +
          checkForColour(data[0]?.product?.attributes) +
          ' | SEVENSTORE'}
      </title>

      <meta
        name="description"
        content={data[0]?.product?.attributes?.short_description}
        data-react-helmet="true"
      />

      <meta
        name="keywords"
        content={data[0]?.product?.categorykeywords.join()}
        data-react-helmet="true"
      />

      <meta
        property="og:url"
        content={data[0]?.product.url}
        data-react-helmet="true"
      />

      <meta property="og:type" content="website" data-react-helmet="true" />

      <meta
        property="og:title"
        content={
          data[0]?.product?.attributes?.brand +
          ' ' +
          data[0].product.name +
          ' | ' +
          checkForColour(data[0]?.product?.attributes) +
          ' | SEVENSTORE'
        }
        data-react-helmet="true"
      />

      <meta
        property="og:description"
        content={data[0]?.product?.attributes?.short_description}
        data-react-helmet="true"
      />

      <meta
        property="og:image"
        content={data[0]?.product?.image}
        data-react-helmet="true"
      />

      <meta
        name="twitter:card"
        content="summary_large_image"
        data-react-helmet="true"
      />

      <meta
        property="twitter:domain"
        content="sevenstore.com"
        data-react-helmet="true"
      />

      <meta
        property="twitter:url"
        content={data[0]?.product.url}
        data-react-helmet="true"
      />

      <meta
        name="twitter:title"
        content={
          data[0]?.product?.attributes?.brand +
          ' ' +
          data[0]?.product.name +
          ' | ' +
          checkForColour(data[0]?.product?.attributes) +
          ' | SEVENSTORE'
        }
        data-react-helmet="true"
      />

      <meta
        name="twitter:description"
        content={data[0]?.product?.attributes?.short_description}
        data-react-helmet="true"
      />

      <meta
        name="twitter:image"
        content={data[0]?.product?.image}
        data-react-helmet="true"
      />
    </Helmet>
  );
};

export default Header;
